export default __webpack_public_path__ + "static/media/MindHealthBC.3bceb698.png";